import erc20Abi from "./abis/erc20.json";
import ownableAbi from "./abis/ownable.json";
import epochBaseAbi from "./abis/EpochBase.json";
import epochWalletAbi from "./abis/EpochWallet.json";
import epochWalletRegistryAbi from "./abis/WalletRegistry.json";

const abis = {
  erc20: erc20Abi,
  ownable: ownableAbi,
  epochBase: epochBaseAbi,
  epochWallet: epochWalletAbi,
  epochWalletRegistry: epochWalletRegistryAbi,
};

export default abis;
